<template>
  <div class="quotes">
    <b-container fluid>
      <h1>Quotations</h1>

      <b-row>
        <b-col>
          <b-form-group label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria" v-model="filterForm_filterKeyword" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button variant="outline-primary" @click="search">Search</b-button>
                <b-button @click="cleanFilterInfo()" variant="outline-primary"><b-icon icon="x-circle" variant="outline-primary"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-pagination
        v-model="currentPage"
        :page="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>

      <b-dropdown variant="primary" text="Create Quote">
        <b-dropdown-item @click="createQuote('monument')">Monument <b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="createQuote('inscription')">Additional Inscription <b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item>
      </b-dropdown>

      <b-table
        class="pointer mt-2"
        id="my-table"
        responsive
        striped
        hover
        @row-clicked="myRowClickHandler"
        :fields="quote_fields"
        :filter="filterCriteria"
        :filter-included-fields="filterOn"
        :items="quotes"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >

      <template #cell(created_by_name)="row">
        <span>{{row.item.created_by_name}}
          <b-button class="py-1" variant="outline-info" size="sm"><b-icon style="font-size: 1rem;" icon="wrench" @click="modifyName(row.item)"></b-icon></b-button>
        </span>
      </template>

      <template #cell(status)="row">
        <span @click="modifyStatus(row.item)">{{row.item.status}}
          <b-button class="py-1" variant="outline-info" size="sm"><b-icon style="font-size: 1rem;" icon="wrench"></b-icon></b-button>
        </span>
      </template>
      
      <template #cell(actions)="row">
        <div class="table-cell">
          <b-button class="table-button" size=sm variant="primary" @click="viewQuote(row.item)">View</b-button>
          <b-button class="table-button ml-1" size=sm variant="danger" @click="delete_quote(row.item.id)">Delete</b-button>
        </div>
      </template>
      <!-- customer_name -->

      <template #cell(customer_name)="row">
        <div class="table-cell">
          {{ row.item.customer_name }} 
          <b-badge class="mx-1" variant="success" v-if="row.item.orderId != null && row.item.orderId.length > 0">
            CRM
          </b-badge>
        </div>
      </template>
      
      </b-table>
    </b-container>

    <b-modal id="modal-delete-quote"
      title="Delete confirmation"
      hide-footer>
      <p>This operation will delete a quote.</p>
      <div class="modal-footer mt-1">
        <b-button variant="secondary" @click="hideModal('modal-delete-quote')"> Cancel </b-button>
        <b-button type="submit" variant="primary" @click="delete_quote_task()"> Delete </b-button>
      </div>
    </b-modal>

    <b-modal id="modal-modify-creator"
      title="Modify creator"
      hide-footer>
      <b-form @submit.prevent="modifyNameTask">
        <label for="original_name">Original name:</label>
        <p>{{this.selectedRow.created_by_name}}</p>
        <label for="new_name">New name:</label>
        <b-form-select 
          v-model="new_creator_name"
          :options="sales_names"></b-form-select>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-modify-creator')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-modify-status"
      title="Modify status"
      hide-footer>
      <b-form @submit.prevent="modifyStatusTask">
        <label for="original_name" class="bold">Original status:</label>
        <p>{{this.selectedRow.status}}</p>
        <strong v-if="this.selectedRow.status == 'fail'">Reason:</strong>
        <p>{{this.selectedRow.failed_reason}}</p>
        <label class="bold" for="new_name">New status:</label>
        <b-form-select 
          v-model="new_status"
          :options="new_status_names"></b-form-select>
        <label v-if="this.new_status == 'fail'" for="new_failed_reason">Reason:</label>
        <b-form-input id="new_failed_reason"
          v-if="this.new_status == 'fail'"
          v-model="new_failed_reason"></b-form-input>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-modify-status')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app';

  export default ({
    data() {
      return {
        filterOn: [
          'create_date',
          'created_by_name',
          'customer_name',
          'customer_phone',
          'customer_cemetery',
          'status'
        ],
        perPage: 20,
        currentPage: 1,
        filterCriteria: "",
        quotes: [],
        tableIsBusy: true,
        deleted_quote_id: "",
        quote_fields: [
          { key: 'create_date', label: 'Create Date'},
          { key: 'created_by_name', label: 'Sales'},
          { key: 'customer_name', label: 'Customer Name'},
          { key: 'customer_phone', label: 'Customer Phone'},
          { key: 'customer_cemetery', label: 'Cemetery'},
          { key: 'status', label: 'status'},
          { key: "actions", label: "Actions"},
        ],
        selectedRow: {},
        new_creator_name: "",
        new_status: "",
        new_status_names: ["success",
          "pending",
          "fail"],
        new_failed_reason: "",
        sales: [],
        sales_names: [],
        filterForm_filterKeyword: ""
      }
    },
    props: {
      user: Object,
      filterInfo:{
        filterForm_filterKeyword: '', 
        filterForm_filterOn: ''
      },
      globalCurrentPage: Number,
    },
    computed: {
      rows: {
        get() {
          if (this.quotes.length == 0) {
            return 100;
          } else {
            return this.quotes.length;
          }
        },
        set(newRows) {
          return newRows
        }
      },
    },
    created() {
      this.$emit('ResetCRMOrder');
      
      firebase.firestore().collection("saless").onSnapshot((collection) => {
        this.sales = collection.docs.map(doc => doc.data());
        for (var i = 0; i < this.sales.length; i++) {
          this.sales_names.push(this.sales[i].name);
        }
      });

      if (this.user.role == "sales") {
        firebase.firestore().collection("quotes").where("created_by_name", "==", this.user.name).orderBy("create_date", "desc").onSnapshot((collection) => {
          this.quotes = collection.docs.map(doc => doc.data());
          this.setTableParameters();
          // this.rows = this.quotes.length
          this.tableIsBusy = false;
        });
      } else {
        firebase.firestore().collection("quotes").orderBy("create_date", "desc").onSnapshot((collection) => {
          this.quotes = collection.docs.map(doc => doc.data());
          this.setTableParameters();
          // this.rows = this.quotes.length
          this.tableIsBusy = false;
        });
      }
    },
    watch: {
      currentPage(newCurrentPage) {
        this.$emit('changeGlobalPage', newCurrentPage);
      },
    },
    methods: {
      search() {
        this.filterCriteria = this.filterForm_filterKeyword;
        const filterInfo = {
          filterForm_filterKeyword: this.filterForm_filterKeyword,
          filterForm_filterOn: this.filterForm_filterOn
        }
        this.currentPage = 1;
        this.$emit('changeFilterInfo', filterInfo);
      },
      setTableParameters(){
        if (this.globalCurrentPage <= (this.rows / this.perPage + 1)) {
          this.currentPage = this.globalCurrentPage;
        }
        if(this.filterInfo != null) {
          this.filterForm_filterKeyword = this.filterInfo.filterForm_filterKeyword;
          this.filterForm_filterOn = this.filterInfo.filterForm_filterOn;
        }
      },
      modifyName(row) {
        this.selectedRow = row;
        this.showModal("modal-modify-creator");
      },
      modifyNameTask() {
        this.selectedRow.created_by_name = this.new_creator_name;
        firebase.firestore().collection("quotes").doc(this.selectedRow.id)
        .set(this.selectedRow,
          {merge: true})
          .then(() => {
            this.hideModal("modal-modify-creator");
            alert("Modify successfully");
          });
      },
      modifyStatus(row) {
        this.selectedRow = row;
        this.showModal("modal-modify-status");
      },
      modifyStatusTask() {
        this.selectedRow.status = this.new_status;
        this.selectedRow.failed_reason = this.new_failed_reason;
        firebase.firestore().collection("quotes").doc(this.selectedRow.id)
        .set(this.selectedRow,
          {merge: true})
          .then(() => {
            this.hideModal("modal-modify-status");
            this.new_status = "";
            alert("Modify successfully");
          });

        firebase.firestore().collection("daily_reports").where('customer_name', '==', this.selectedRow.customer_name).get().then((collection) => {
          var reports = collection.docs.map((doc) => doc.data());
          reports.forEach((data) => {
            console.log(data);
            data.status = this.selectedRow.status;
            const report_ref = firebase.firestore().collection("daily_reports").doc(data.id);
            report_ref.set(data, {merge: true});
          });
        });
      },
      myRowClickHandler(item) {
        console.log(item);
      },
      createQuote(type) {
        this.$emit("createQuote", type);
      },
      viewQuote(quote) {
        console.log(quote);
        this.$emit('viewQuote', {quote: quote, from: 'Quotes'});
      },
      hideModal(id) {
        this.$bvModal.hide(id);
      },
      showModal(id) {
        this.$bvModal.show(id);
      },
      delete_quote(id) {
        if (this.user.role != "admin") {
          alert("You do not have authority.");
        } else {
          this.deleted_quote_id = id;
          this.showModal("modal-delete-quote");
        }
      },
      delete_quote_task() {
        firebase.firestore().collection("quotes").doc(this.deleted_quote_id).delete()
          .then(() => {
            this.hideModal("modal-delete-quote");
            alert("delete successfully");
          });
      },
      cleanFilterInfo() {
        this.filterForm_filterKeyword = '';
      },
    }
  })
</script>

<style scoped>
.table-button {
  display: inline-block;
}

.table-cell {
  min-width: 120px;
}
</style>
